"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfiguracaoNaoPrograma = void 0;
var bson_1 = require("bson");
var ConfiguracaoNaoPrograma = /** @class */ (function () {
    function ConfiguracaoNaoPrograma(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.versao, versao = _c === void 0 ? '' : _c, _d = _a.descricao, descricao = _d === void 0 ? '' : _d, _e = _a.marca, marca = _e === void 0 ? [] : _e, _f = _a.estacaoColecao, estacaoColecao = _f === void 0 ? [] : _f, _g = _a.linhaDeProduto, linhaDeProduto = _g === void 0 ? [] : _g, _h = _a.destinoDeConfeccao, destinoDeConfeccao = _h === void 0 ? [] : _h, _j = _a.categoriaProduto, categoriaProduto = _j === void 0 ? [] : _j, _k = _a.material, material = _k === void 0 ? [] : _k, _l = _a.quantidade, quantidade = _l === void 0 ? 0 : _l, _m = _a.pv, pv = _m === void 0 ? [] : _m, _o = _a.tipoDeProduto, tipoDeProduto = _o === void 0 ? [] : _o, _p = _a.tamanhos, tamanhos = _p === void 0 ? [] : _p, _q = _a.lock, lock = _q === void 0 ? false : _q, _r = _a.cores, cores = _r === void 0 ? [] : _r, _s = _a.faixaOperacional, faixaOperacional = _s === void 0 ? [] : _s;
        this._id = _id;
        this.versao = versao;
        this.descricao = descricao;
        this.marca = marca;
        this.estacaoColecao = estacaoColecao;
        this.linhaDeProduto = linhaDeProduto;
        this.destinoDeConfeccao = destinoDeConfeccao;
        this.categoriaProduto = categoriaProduto;
        this.material = material;
        this.quantidade = quantidade;
        this.pv = pv;
        this.tipoDeProduto = tipoDeProduto;
        this.tamanhos = tamanhos;
        this.lock = lock;
        this.cores = cores;
        this.faixaOperacional = faixaOperacional;
    }
    return ConfiguracaoNaoPrograma;
}());
exports.ConfiguracaoNaoPrograma = ConfiguracaoNaoPrograma;
//# sourceMappingURL=ConfiguracaoNaoPrograma.js.map